export function LineDivider() {
  return <div className={"h-px my-4 bg-slate-200 w-full"} />;
}
